import React, { useState } from 'react';
import { includes } from 'lodash';

import { useAppDispatch, useAppSelector } from 'utils/hooks';
import { GIFT_NOTE_RESERVED_COLLECTION } from 'utils/globals';

import photoModule from 'domains/photos';

import Button from 'components/shared/Button';
import Modal from 'components/shared/Modal';

type SaveUncollectedModalProps = {
  lastFocusedElementId: string;
  onCancel: () => void;
};

function SaveUncollectedModal(props: SaveUncollectedModalProps) {
  const { lastFocusedElementId, onCancel } = props;

  const [pendingName, setPendingName] = useState('');

  const dispatch = useAppDispatch();
  const existingNames = useAppSelector(photoModule.selectors.allCollectionNames);

  function handleSaveAsNewCollectionClick() {
    dispatch(photoModule.actions.moveUncollectedToCollection(pendingName));
  }

  const buttons = (
    <React.Fragment>
      <Button
        type="confirm"
        onClick={handleSaveAsNewCollectionClick}
        disabled={
          pendingName === '' ||
          includes(existingNames, pendingName) ||
          pendingName === GIFT_NOTE_RESERVED_COLLECTION
        }
      >
        Save as New Collection
      </Button>
      <Button type="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </React.Fragment>
  );

  return (
    <Modal
      title="Save Uncollected Photos as a Collection"
      labelledBy="save-uncollected-photos-modal"
      lastFocusedElementId={lastFocusedElementId}
      onClose={onCancel}
      primaryFooterGroup={buttons}
    >
      <div className="collections_manager_container">
        <p>Your uncollected images will be saved as a new collection.</p>
        <p>Give the new collection a name.</p>
        <div>
          <label htmlFor="save-uncollected-name" className="screen-reader-text">
            New Collection Name
          </label>
          <input
            id="save-uncollected-name"
            name="collectionName"
            placeholder="New Collection"
            onChange={(e) => setPendingName(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
}

export default SaveUncollectedModal;
